module.exports = __webpack_public_path__ + "static/media/deadline.251491b9.svg";